// ======================================================================
// File Name       : ServiceNotificationListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, getFormValues } from 'redux-form';
import moment from 'moment';
import MessageSearch from '../../components/MessageSearch';
import Header from '../../components/Header';
import * as ServiceAction from '../../actions/ServiceAction';
import ServiceNotificationListSearch from '../../components/service/serviceNotification/ServiceNotificationListSearch';
import ServiceNotificationList from '../../components/service/serviceNotification/ServiceNotificationList';
import { SERVICE_NOTIFICATION_LIST, SERVICE_NOTIFICATION_DETAIL } from '../../constants/PathConstants';
import {
  RETURN_MAX_NUM,
  SELECT_TARGET_DATA,
  DEFAULT_DATE_FORMAT_SERVER,
} from '../../constants/index';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as actionType from '../../constants/actionTypes/page';

class ServiceNotificationListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showExportModal: false,
      isAllowShowSearchMessage: false,
    };
    this.initData = this.initData.bind(this);
    this.searchData = this.searchData.bind(this);
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this);
    this.onExportBtnClick = this.onExportBtnClick.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.onExportDialogOk = this.onExportDialogOk.bind(this);
    this.onExportDialogCancel = this.onExportDialogCancel.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.createParams = this.createParams.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    this.initData();
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.noticeSortType) {
        column = initialValues.noticeSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(initialValues, startPosition, column, SELECT_TARGET_DATA.DATA);
    this.props.dispatch(ServiceAction.getServiceNotificationList(param));
  }

  searchData(startPosition, column) {
    const { formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const param = this.createParams(formValues, startPosition, column, SELECT_TARGET_DATA.DATA);
    this.props.dispatch(ServiceAction.getServiceNotificationList(param)).then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  onSearchBtnClick() {
    const { invalid } = this.props;
    if (invalid) return;
    this.props.change('startPosition', 0);
    this.searchData(0);
  }

  onExportBtnClick() {
    const { formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    this.setState({
      showExportModal: true,
    });
  }

  onExportDialogOk() {
    const { formValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (formValues) {
      if (formValues.noticeSortType) {
        column = formValues.noticeSortType;
      }
      if (formValues.startPosition) {
        startPosition = formValues.startPosition;
      }
    }
    this.setState({
      showExportModal: false,
    }, () => {
      const param = this.createParams(formValues, startPosition, column, SELECT_TARGET_DATA.CSV);
      this.props.dispatch(ServiceAction.exportServiceNotificationList(param));
    });
  }

  onExportDialogCancel() {
    this.setState({
      showExportModal: false,
    });
  }

  getStartEndData(startPosition) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchData(startPosition);
  }

  handleSortState(column) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchData(null, column);
  }

  createParams(searchInfo, startPosition, column, selectTargetData) {
    const param = {};
    param.selectTargetData = selectTargetData;
    const paramSearchInfo = {};
    paramSearchInfo.returnMaxNum = RETURN_MAX_NUM;
    searchInfo.noticeTitle && (paramSearchInfo.noticeTitle = searchInfo.noticeTitle);
    !isNaN(parseInt(searchInfo.userType, 10)) && (paramSearchInfo.userType = searchInfo.userType);
    !isNaN(parseInt(searchInfo.publicStatus, 10)) &&
      (paramSearchInfo.publicStatus = searchInfo.publicStatus);
    searchInfo.publicDateFrom &&
      (paramSearchInfo.publicDateFrom = moment(searchInfo.publicDateFrom)
        .format('YYYY-MM-DD'));
    searchInfo.publicDateTo &&
      (paramSearchInfo.publicDateTo = moment(searchInfo.publicDateTo)
        .format('YYYY-MM-DD'));
    paramSearchInfo.startPosition = searchInfo.startPosition || 0;
    if (!isNaN(parseInt(startPosition, 10))) {
      paramSearchInfo.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      paramSearchInfo.ascendingDescendingSort = column.sortState;
      paramSearchInfo.noticeSortType = column.sortBy;
    }
    param.searchInfo = paramSearchInfo;
    return param;
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: SERVICE_NOTIFICATION_LIST,
      searchCondition: formValues,
    });
  }

  goToDetail(noticeSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: SERVICE_NOTIFICATION_LIST,
        searchCondition: formValues,
      });
    }
    const path = SERVICE_NOTIFICATION_DETAIL.replace(':id', noticeSecernId);
    this.props.history.push(path);
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { formValues, serviceNotiRecordNum, serviceNotice, startPosition, serviceType } = this.props;
    const {
      hoverIndex
    } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={serviceNotiRecordNum}
          resultList={serviceNotice ? serviceNotice.allSecernIds : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Header name="サービス向けお知らせ情報の一覧" />
        <ServiceNotificationListSearch
          {...formValues}
          onSearchBtnClick={this.onSearchBtnClick}
          onExportBtnClick={this.onExportBtnClick}
          serviceType={serviceType}
        />
        <ServiceNotificationList
          serviceNotice={serviceNotice}
          startPosition={startPosition}
          recordNum={serviceNotiRecordNum}
          getStartEndData={this.getStartEndData}
          handleSortState={this.handleSortState}
          goToDetail={this.goToDetail}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onExportDialogCancel}
          content={MessageTemplate.BULK_EXPORT}
          onOK={this.onExportDialogOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceNotificationListSearchForm } = state.form;
  const { parentPath, searchCondition } = state.page;
  const { authedUser: { serviceType } } = state.authed;
  let initial = {};
  if (parentPath === SERVICE_NOTIFICATION_LIST) {
    initial = searchCondition;
  }
  const { serviceNotice, serviceNotiRecordNum } = state.service;
  return {
    serviceNotificationListSearchForm,
    serviceNotiRecordNum,
    serviceNotice,
    invalid: isInvalid('serviceNotificationListSearchForm')(state),
    formValues: getFormValues('serviceNotificationListSearchForm')(state),
    initialValues: initial,
    serviceType,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'serviceNotificationListSearchForm',
    touchOnChange: true,
  })(ServiceNotificationListContainer),
);
